import { NumberSpacerValueConverter } from 'value-converters/number-spacer';

const numberConvert = new NumberSpacerValueConverter();

const toKg = (value: string | number) => (value ? `${numberConvert.toView(value)} kg` : '-');
const toM = (value: string | number) => (value ? `${numberConvert.toView(value)} m` : '-');
const toLiter = (value: string | number) => (value ? `${numberConvert.toView(value)} L` : '-');
const toChecked = (value: boolean) => (value ? 'X' : '-');
const toFixed = (value: number | string, fixed = 2) => (value ? +(+value.toString()).toFixed(fixed) : 0);

export { toKg, toM, toChecked, toFixed, toLiter };
